import Err from '@leverege/error'

export default function ScriptApi( api, script ) {
  
  let path = null
  if ( script ) {
    if ( typeof script === 'string' ) {
      path = `v1/script/${script}`
    } else if ( script.projectId && script.id ) {
      path = `v1/project/${script.projectId}/script/${script.id}`  
    } else if ( script.id ) {
      path = `v1/script/${script.id}`
    }
  }
  if ( path == null ) {
    throw Err( 'invalid script' )
  }
  const connect = api.child( path )

  // set data directly
  function setCode( code ) {
    return connect.patch( [ { path : 'code', value : code, op : 'replace' } ] )
  }

  // Simulation
  function deploy( options ) {
    return connect.child( 'deploy' ).post( null, options )
  }

  // Simulation
  function undeploy( options ) {
    return connect.child( 'deploy' ).delete( null, options )
  }

  function logs( options ) {
    return connect.child( 'logs' ).get( options )
  }

  function metrics( options ) {
    return connect.child( 'metrics' ).get( options )
  }

  return {
    get : connect.get,
    update : connect.patch,
    delete : connect.delete,

    deploy,
    undeploy,
    setCode,
    logs,
    metrics

  }
}
